import React, { useEffect } from 'react';
import usePublicPDFPage from './usePublicPDFPage';
import { Container, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import PDFCard from '../PDFCard/PDFCard';
import useOpenSignatory from '../useOpenSignatory';
import Modal from '../../../components/Modal/Modal';
import Loader from '../../../components/Loader/Loader';
import SignatoryPage from '../SignatoryPage/SignatoryPage';
import { getFileICon } from '../../../utils/utilities';

const styles = {
    container: {
        position: 'relative',
        width: '100%',
        height: '80vh', // Use vh for responsive height
        overflow: 'hidden',
    },
    responsiveIframe: {
        width: '100%',
        height: '100%', // Fill the container
        border: 'none',
    },
};

const PublicPDFPage = () => {

    const { 
        isMounted,
        handleViewFile,
        sharedTemplate,
        expirationDate,
        type,
        signButtonLabel
    } = usePublicPDFPage();

    const {
        handleOpenSignatories,
        openedFile,
        modalBtn
    } = useOpenSignatory();
 
    return (
        <>
            {isMounted &&
                <Container maxWidth="xxl" sx={{ mb: 6 }} >
                    <Paper elevation={5} sx={{ my: { xs: 2, md: 3 }, p: { xs: 2, md: 3 } }}>
                        <Typography variant="subtitle1" sx={{ p: 2 }} >
                            This document is being shared with you for your signature.
                        </Typography>
                        <Typography variant="subtitle1" sx={{ pl: 2 , pb: 2 }} >
                            Expiration Date: <strong>{expirationDate}</strong>
                        </Typography>
                        <Grid container spacing={2}>
                            <PDFCard
                                title={type === "0" ? `${sharedTemplate.FormName}.pdf` : `${sharedTemplate.FormName}`}
                                file={sharedTemplate}
                                handleViewFile={() => handleViewFile(sharedTemplate)}
                                handleOpenSignatories={type === "0" ? () => handleOpenSignatories(sharedTemplate) : ""}
                                fileIcon={getFileICon(type === "0" ? `${sharedTemplate.FormName}.pdf` : `${sharedTemplate.FormName}`)}
                                signButtonLabel={signButtonLabel}
                                onSharedView={true}
                            />
                        </Grid>

                    </Paper>
                </Container>
            }

            <Modal
                isOpen={openedFile ? true : false}
                title={`Signatories for ${openedFile?.FormName}`}
                onModalClose={modalBtn.onModalClose}
            >
                {openedFile &&
                    <SignatoryPage
                        openedFile={openedFile}
                    />
                }
            </Modal>
        </>
    )
}

export default PublicPDFPage;